import { Empty } from "components/Empty";
import FilterButtonGroup from "components/FilterButtonGroup";
import { useField } from "lib/form";
import { device, mq } from "lib/media-query";
import React from "react";
import { useFilter } from "services/filter";
import { useCount } from "services/search";
import styled from "styled-components";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    ${mq.to(device.TABLET)`
     grid-template-columns: 1fr;
  `};
    ${({ condensed }) => (condensed ? "grid-template-columns: 1fr" : "")}
`;

export const AantalDeurenFilter = ({ condensed }) => {
    const filterOptions = useFilter("aantalDeuren");
    const count = useCount("aantalDeuren");
    const [value, , onChange] = useField("aantalDeuren");

    const options =
        filterOptions.map((option) => ({
            id: option,
            displayName: `${option}`,
            naam: `${option}`,
            aantal: count[option] || 0
        })) || [];

    return (
        <Grid condensed={condensed}>
            <FilterButtonGroup
                filterId="filter-aantal-deuren"
                options={options}
                value={value || []}
                handleChange={(_, v) => onChange(v)}
                datalayerKey="aantalDeuren"
                columns={condensed ? 2 : 6}
            />
            <Empty />
        </Grid>
    );
};
